import { Platform } from "react-native";

/**
 * Input font size that prevents iOS Safari auto-zoom on focus.
 *
 * iOS Safari zooms into any input with font-size < 16px when the input
 * receives focus. On native and mobile-web (touch) devices we always
 * return 16. On desktop-web (non-touch) we can return a smaller size
 * later — for now everything is 16.
 */
export function useInputFontSize(): number {
  if (Platform.OS !== "web") return 16;
  if (
    typeof window !== "undefined" &&
    window.matchMedia("(pointer: coarse)").matches
  ) {
    return 16;
  }
  return 14;
}
